export enum BlendType{
    /**混合枚举_禁用。*/
	BLEND_DISABLE = 0,
	/**混合枚举_启用_RGB和Alpha统一混合。*/
	BLEND_ENABLE_ALL = 1,
	/**混合枚举_启用_RGB和Alpha单独混合。*/
	BLEND_ENABLE_SEPERATE = 2
}